import script from "./ForumWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumWidget.vue?vue&type=script&setup=true&lang=js"

import "./ForumWidget.vue?vue&type=style&index=0&id=40395ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40395ff6"]])

export default __exports__